export const FORCE_DISCONNECT_SIGNAL = 'force_disconnect';

export const RECORDING_REFUSED_SIGNAL = 'recording_refused';

export const MAX_CONNECTIONS = 2;

export const PUBLISHER_STREAM_ID = 'publisher_stream';

export const LIVE_CONF_AUTO_CLOSE_DELAY_IN_SEC = 5;

export const BUSY_ALERT_SHOW_TIME_IN_MINS = 15;
